export const formatDocumentNumber = (value) => {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return `${String(value).padStart(4, '0')}`;
    }

    if (typeof value === 'string' && value.trim().length > 0) {
        return value;
    }

    return '----';
};
